export default {
  error: 'The following problems have been found with the entered data. You must correct them to finish the transaction.'
}
